"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiList = void 0;
exports.MuiList = {
    styleOverrides: {
        root: {
            // forcing 8px padding due to MUI padding-right: 0 scrollbar issue
            padding: '8px !important',
        },
    },
};
//# sourceMappingURL=MuiList.js.map